<template>
	<Row v-if="!isLoading" class="flex-align-center flex-justify-space-between width-100">
		<NotificationIconsBar :selectedIcon="selectedIcon" @choose-mdi-icon="onChooseIcon" :icons="icons" />
		<NotificationIconColorPicker :colors="colors" v-model="activeColor" />
	</Row>
</template>
<script>
import { api } from '@/api/clients';
import NotificationIconColorPicker from '@/components/BlockEditorNotification/CustomizeTabs/CustomizeNotificationMdiIcon/NotificationIconColorPicker.vue';
import NotificationIconsBar from '@/components/BlockEditorNotification/CustomizeTabs/CustomizeNotificationMdiIcon/NotificationIconsBar.vue';

const FILE_NAME_COLOR_DELIMITER = ' _ ';

export default {
	name: 'CustomizeNotificationMdiIcon',
	components: {
		NotificationIconsBar,
		NotificationIconColorPicker,
	},
	props: {
		selectedEntityId: { type: String },
	},
	computed: {
		icons() {
			return this.iconsByColor[this.activeColor] || [];
		},
		colors() {
			return Object.keys(this.iconsByColor) || [];
		},
	},
	methods: {
		onChooseIcon(iconName) {
			this.selectedIcon = iconName;
			const icon = this.icons.find((icon) => icon.name === iconName);
			this.$emit('change-icon', { icon: `${process.env.VUE_APP_APP_URL}${icon.pathname}`, entity_id: icon.name });
		},
		getIconPathname(iconName, iconColor) {
			return `notificationIcons/${iconColor}/${iconName}.png`.replaceAll(' ', '%20');
		},
		async getIconsByColor() {
			return api.get(`${process.env.VUE_APP_APP_URL}assets/json/notification-icons.json`);
		},
	},
	async created() {
		this.isLoading = true;
		try {
			this.iconsByColor = await this.getIconsByColor();
		} catch {
			this.$toast.error('Failed to load icons');
		} finally {
			this.isLoading = false;
		}
		if (this.selectedEntityId) {
			this.selectedIcon = this.selectedEntityId;
			this.activeColor = this.selectedEntityId.split(FILE_NAME_COLOR_DELIMITER)[1];
		} else {
			this.activeColor = this.colors[0];
			this.selectedIcon = this.icons[0].name;
		}
	},
	data() {
		return {
			iconsByColor: {},
			searchString: '',
			isLoading: false,
			activeColor: null,
			selectedIcon: null,
		};
	},
	watch: {
		activeColor: {
			handler(newV, oldV) {
				if (newV && oldV && this.selectedIcon) {
					this.onChooseIcon(this.selectedIcon.replace(oldV, newV));
				}
			},
		},
	},
};
</script>
<style scoped lang="scss"></style>
